import {Divider, message} from 'antd'
import {auth_login_Api} from 'apis'
import {NullAsDefault} from 'views/Shared'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {useDispatch} from 'react-redux'
import {loginSuccess} from 'redux/actions'
import {renderIfElse} from '../Shared'
import GoogleLoginBtn from './GoogleLoginBtn/index'
import './Login.css'
import LoginForm from './LoginForm'
import {useToggle} from 'react-use'
import {FcGoogle} from 'react-icons/fc'

const LoginOrSkip = ({ onSuccess = NullAsDefault }) => {
    const t = useTranslate()
    const dispatch = useDispatch()
    const [isToggle, toggle] = useToggle()

    const { isLoading, handleAsyncAction } = useAsyncAction({
        apiInfo: auth_login_Api,
        onSuccess: (...args) => {
            dispatch(loginSuccess(_.get(args, '1.response.data')))
            onSuccess()
        },
        onError: (...args) => message.error(_.get(args, '1.message')),
    })

    return (
        <div className="flex flex-col gap-6 px-5 pt-6 pb-5">

            {/* Header */}
            <div className="flex flex-col items-center gap-1">
                <span
                    style={{ fontSize: 18, fontWeight: 700, letterSpacing: '-0.01em' }}
                    className="text-color-000">
                    {t('login on')}
                </span>
                <span
                    style={{ fontSize: 13, fontWeight: 500 }}
                    className="text-primary">
                    {'Kristo Network'}
                </span>
            </div>

            {renderIfElse(
                isToggle,
                /* ── Đăng nhập bằng tài khoản Kristo ── */
                <div className="flex flex-col gap-4">
                    <div
                        style={{ fontSize: 13 }}
                        className="text-center text-color-400 italic">
                        {t('with account')} Kristo Network
                    </div>
                    <LoginForm />
                    <button
                        onClick={toggle}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: 13,
                            color: 'var(--text-color-400)',
                            textDecoration: 'underline',
                            textUnderlineOffset: 3,
                        }}>
                        ← {t('back')}
                    </button>
                </div>,

                /* ── Màn chọn phương thức đăng nhập ── */
                <div className="flex flex-col gap-3">

                    {/* Google — CTA chính */}
                    <GoogleLoginBtn
                        onSuccess={handleAsyncAction}
                        renderButton={
                            <div
                                style={{
                                    height: 44,
                                    borderRadius: 10,
                                    border: '1px solid #dadce0',
                                    background: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 10,
                                    cursor: 'pointer',
                                    transition: 'box-shadow 0.15s',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                }}
                                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)'}
                                onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)'}>
                                <FcGoogle size={20} />
                                <span style={{ fontSize: 14, fontWeight: 600, color: '#3c4043', letterSpacing: '0.01em' }}>
                                    {t('Sign in with Google')}
                                </span>
                            </div>
                        }
                    />

                    {/* Kristo account — CTA thứ hai */}
                    <div
                        onClick={toggle}
                        style={{
                            height: 44,
                            borderRadius: 10,
                            border: '1.5px solid var(--color-primary, #6366f1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            gap: 8,
                            transition: 'background 0.15s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = 'var(--color-primary-50, #eef2ff)'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--color-primary, #6366f1)', letterSpacing: '0.01em' }}>
                            {t('Sign in with account')}{' Kristo'}
                        </span>
                    </div>

                    <Divider
                        style={{
                            margin: '4px 0',
                            color: 'var(--text-color-500)',
                            fontSize: 12,
                        }}
                        className="lowercase">
                        {t('or')}
                    </Divider>

                    {/* Skip — tertiary, ít quan trọng nhất */}
                    <div
                        onClick={() => onSuccess()}
                        style={{ textAlign: 'center', cursor: 'pointer', padding: '4px 0' }}>
                        <span
                            style={{
                                fontSize: 13,
                                color: 'var(--text-color-400)',
                                textDecoration: 'underline',
                                textUnderlineOffset: 3,
                                letterSpacing: '0.01em',
                            }}>
                            {t('skip login')}
                        </span>
                    </div>

                </div>
            )}

        </div>
    )
}

export default LoginOrSkip